<template>
  <div class="concern-companies-empty">
    <img class="empty-img" src="../../assets/img/empty-img.svg" alt="">
    <div class="empty-word">
      <div>尊敬的用户，您当前尚未关注任何公司，可以通过以下方式管理关注公司：</div>
      <div>1、点击“<span @click="manageConcerns" class="empty-word-btn">管理关注内容</span>”，添加想要关注的公司；</div>
      <div>2、进入具体公司页面，通过点击左上角的“+加关注”按钮添加关注公司</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    manageConcerns() {
      this.$router.push('/follow');
    }
  }
};
</script>

<style lang="scss" scoped>
.concern-companies-empty {
  position: relative;
  width: 100%;
  margin-top: 10px;
  height: calc(100vh - 146px);
  background-color: #ffffff;
  .empty-img {
    position: absolute;
    top: 180px;
    left: 50%;
    transform: translateX(-50%);
  }
  .empty-word {
    position: absolute;
    top: 350px;
    left: 50%;
    transform: translateX(-50%);
    color: #747990;
    font-size: 14px;
    &-btn {
      color: #45a8cc;
      cursor: pointer;
    }
  }
}
</style>
